import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-maxthon",
  "use": "icon-maxthon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-maxthon\"><defs><style type=\"text/css\"></style></defs><path d=\"M417.003 879.416c-15.987-6.781-23.597-16.16-23.234-36.193 1.641-90.471 1.398-180.995 0.373-271.485-0.266-23.517 5.293-33.723 31.201-33.09 65.716 1.596 131.491 0.527 199.266 0.527 1.554 9.326 3.937 17.014 3.964 24.706 0.27 95.199 0.4 190.404-0.082 285.605-0.042 9.983-4.172 19.953-6.409 29.93H417.003zM240.124 873.027H6.751V152.706c12.551-0.594 25.096-1.709 37.64-1.709 237.941-0.052 475.883-0.259 713.824 0.193 147.115 0.276 259.279 111.426 260.164 258.725 0.911 150.761 0.027 301.533-0.166 452.302 0 2.222-1.091 4.438-2.507 9.785H786.169v-485.35H240.124v486.375z\" p-id=\"19680\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uas/maxthon.svg
// module id = HyWl
// module chunks = 16